export default __webpack_public_path__ + "static/media/payments.db33ef1e.png";